import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';
import { createGradientOrSolid } from 'utils/index';
import { Gradient } from 'utils/types';

export const StyledBanditos = styled.div<{
  backgroundSrc?: string;
  backgroundColor: Gradient;
  inMobileMock: boolean;
  ribbonBadge: string;
}>`
  width: 100%;
  height: 226px;
  width: 100%;
  min-width: 340px;
  max-width: 340px;
  border-radius: 16px;
  font-family: var(--font-family), Arial;
  background: ${({ backgroundSrc, backgroundColor }) =>
    backgroundSrc
      ? `url("${backgroundSrc}")`
      : createGradientOrSolid(backgroundColor)};
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  margin-bottom: 14px;

  .container {
    padding: 8px 12px 12px;
    color: #fff;
    text-shadow: 1px 1px 1px #000, -1px -1px 1px #000, 1px -1px 1px #000,
      -1px 1px 1px #000;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    position: relative;

    .ribbon-badge {
      background-image: url(${({ ribbonBadge }) => ribbonBadge});
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      width: 100%;
      height: 100%;
      max-width: 56px;
      min-width: 56px;
      max-height: 56px;
      min-height: 56px;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 10;

      &-text {
        font-weight: 900;
        line-height: normal;
        text-shadow: 1px 1px 1px #000, -1px -1px 1px #000, 1px -1px 1px #000,
          -1px 1px 1px #000;
        width: 32px;
        margin: 11px auto 0;

        div {
          font-size: calc(clamp(4px, 1em * 1.17, 14px));
          text-align: center;
          margin: 0 auto 0;
          max-width: 32px;
        }
      }
    }

    .title {
      font-size: 22px;
      position: absolute;
      top: 8px;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      text-align: center;
    }

    .timer {
      font-size: 14px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 38px;
    }

    .availability {
      font-size: 16px;
      position: absolute;
      left: 12px;
      bottom: 12px;
    }

    .products {
      display: flex;
      gap: 8px;
      margin: 60px 0 auto auto;
      max-width: 200px;
      flex-wrap: wrap;
      width: 100%;
      justify-content: end;

      .product {
        background-color: #ffdd8b;
        border: 1px solid #000;
        height: 44px;
        width: 44px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        position: relative;

        img {
          min-height: 26px;
          height: 26px;
          max-height: 26px;
          width: auto;
          object-fit: contain;
          position: absolute;
          top: 5px;
          left: 50%;
          transform: translateX(-50%);
        }

        .quantity {
          margin: auto auto 0;
          z-index: 1;
          font-weight: 900;
          line-height: normal;
          text-shadow: 1px 1px 1px #000, -1px -1px 1px #000, 1px -1px 1px #000,
            -1px 1px 1px #000;

          div {
            font-size: 12px;
            width: 36px;
            text-align: center;
          }
        }

        .stroked {
          z-index: 1;
          font-weight: 900;
          line-height: normal;
          text-shadow: 1px 1px 1px #000, -1px -1px 1px #000, 1px -1px 1px #000,
            -1px 1px 1px #000;

          div {
            font-size: 10px;
            text-align: center;
            width: 30px;

            position: relative;

            &:before {
              content: '';
              position: absolute;
              background-color: #ff0000;
              height: 2px;
              width: 95%;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(-10deg);
              border-radius: 1px;
            }
          }
        }
      }
    }

    .price {
      margin: auto 0 0 auto;
      width: 100px;
      border-radius: 8px;
      border: 1px solid #000;
      overflow: hidden;
      z-index: 1;
      height: 32px;

      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 102px;
        height: 16px;
        background-color: #87d30c;
        z-index: -1;
        box-shadow: 0 -4px 1px 0 rgba(0, 0, 0, 0.25) inset;
        border-radius: 0 0 8px 8px;
      }

      .totalPrice {
        padding: 0 8px;
        width: 100%;
        div div {
          flex-direction: row-reverse;

          .final-price,
          .stroked {
            text-shadow: 1px 1px 1px #000, -1px -1px 1px #000, 1px -1px 1px #000,
              -1px 1px 1px #000;
            color: #fff;
          }

          .final-price {
            font-size: calc(clamp(4px, 1em * 1.5, 18px));
          }

          .stroked {
            margin-left: 0;
            margin-right: 4px;
            text-decoration: none;
            position: relative;
            font-size: calc(clamp(4px, 1em * 1.33, 16px));

            &:before {
              content: '';
              position: absolute;
              background-color: #ff0000;
              height: 2px;
              width: 105%;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(-10deg);
              border-radius: 1px;
            }
          }
        }
      }
    }
  }

  @media (min-width: ${breakpoints.tablet}) {
    min-width: ${({ inMobileMock }) => (inMobileMock ? '340px' : '450px')};
    max-width: ${({ inMobileMock }) => (inMobileMock ? '340px' : '450px')};
    height: 300px;
    margin-bottom: 18px;
    border-radius: 21px;

    .container {
      padding: 10px 15px 15px;

      .ribbon-badge {
        max-width: 74px;
        min-width: 74px;
        max-height: 74px;
        min-height: 74px;

        &-text {
          width: 40px;
          margin: 15px auto 0;

          div {
            max-width: 40px;
          }
        }
      }

      .title {
        font-size: 28px;
        top: 10px;
      }

      .timer {
        font-size: 18px;
        top: 48px;
      }

      .availability {
        font-size: 20px;
        left: 15px;
        bottom: 15px;
      }

      .products {
        display: flex;
        gap: 10px;
        margin: 80px 0 auto auto;
        max-width: 264px;

        .product {
          height: 58px;
          width: 58px;
          border-radius: 10px;

          img {
            min-height: 32px;
            height: 32px;
            max-height: 32px;
            top: 7px;
          }

          .quantity {
            div {
              font-size: 16px;
              width: 50px;
              text-align: center;
            }
          }

          .stroked {
            div {
              font-size: 14px;
              width: 46px;
            }
          }
        }
      }

      .price {
        height: 44px;
        width: 134px;

        &:before {
          width: 136px;
          height: 22px;
        }

        .totalPrice {
          .isFree {
            font-size: calc(clamp(4px, 1em * 2, 24px));
          }
          div div {
            .final-price {
              font-size: calc(clamp(4px, 1em * 2, 24px));
            }
            .stroked {
              font-size: calc(clamp(4px, 1em * 2, 22px));
            }
          }
        }
      }
    }
  }
`;
